import React from "react";
import "../styles/contact.css";

export default function Contact() {
  return (
    <div className="contact-page">

      {/* ===== HERO ===== */}
      <section className="contact-hero">
        <h1>संपर्क करा</h1>
        <p>बेलपिंपळगाव ग्रामपंचायत – आम्ही तुमच्यासाठी आहोत</p>
      </section>

      {/* ===== CONTACT INFO ===== */}
      <section className="contact-section">
        <div className="contact-cards">

          <div className="contact-card">
            <h3>📍 पत्ता</h3>
            <p>
              ग्रामपंचायत बेलपिंपळगाव<br/>
              तालुका – नेवासा<br/>
              जिल्हा – अहिल्यानगर (अहमदनगर)
            </p>
          </div>

          <div className="contact-card">
            <h3>📞 संपर्क क्रमांक</h3>
            <p>
              कार्यालय : +91 9130372467<br/>
              सरपंच : +91 9657818670
            </p>
          </div>

          <div className="contact-card">
            <h3>📧 ई-मेल</h3>
            <p>belpimpalgaon@gmail.com</p>
          </div>

        </div>
      </section>

      {/* ===== CONTACT FORM ===== */}
      <section className="contact-form-section">
        <h2>तुमचा संदेश पाठवा</h2>

        <form className="contact-form">
          <input type="text" placeholder="तुमचं नाव" required />
          <input type="email" placeholder="ई-मेल" required />
          <input type="text" placeholder="मोबाईल नंबर" />
          <textarea rows="5" placeholder="तुमचा संदेश"></textarea>
          <button type="submit">संदेश पाठवा</button>
        </form>
      </section>

    </div>
  );
}
